<template>
  <div>
    <div class="input-group mb-3" style="background: #F3F5F8 !important;">
      <button class="btn number-input-btn" type="button" id="button-addon1" @click="reduce">
        <i class="icon-reduce"></i>
      </button>
      <input  type="number" inputmode="int" :value="value" @blur="updateValue($event.target.value)" class="form-control" style="text-align: center;background: #F3F5F8 !important;">
      <button class="btn number-input-btn" type="button" id="button-addon1" @click="added">
        <i class="icon-added" ></i>
      </button>
    </div>
  </div>
</template>

<script>
import Decimal from "decimal.js";

export default {
  name: "NumberInput",
  props: {
    value: {
      type:Number,
      required:true,
      default: 0
    },
    max:{
      type:Number,
      default:undefined
    },
    min:{
      type:Number,
      default:undefined
    },
    setAdd:{
      type:Number,
      default:1
    },
    inputModel:{
      type:String,
      default:'int'
    }
  },
  methods: {
    updateValue(newValue) {
      //如果为空则修改为默认值
      if(!newValue){
        newValue = 0
      }
      switch (this.inputModel) {
        case 'decimal':newValue = parseFloat(newValue).toFixed(2); break;
        case 'int':newValue = parseInt(newValue);break;
      }
      // 触发 input 事件将新值传递给父组件
      this.$emit("input", newValue);
    },
    added(){
      if(!(this.max !== undefined && this.value > this.max)){
        if(this.inputModel === 'decimal'){
          const Decimal = require('decimal.js');
          const num1 = new Decimal(this.value);
          const num2 = new Decimal(this.setAdd);
          const result = num1.plus(num2);
          this.updateValue(result);
        }else{
          this.updateValue(this.value+this.setAdd);
        }
      }
      this.$emit("click")
    },
    reduce(){
      if(!(this.min !== undefined && this.value <= this.min)){
        if(this.inputModel === 'decimal'){
          const Decimal = require('decimal.js');
          const num1 = new Decimal(this.value);
          const num2 = new Decimal(this.setAdd);
          const result = num1.minus(num2);
          this.updateValue(result);
        }else{
          this.updateValue( this.value-this.setAdd);
        }
      }
      this.$emit("click")
      // this.$emit("reduce")
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.number-input-btn{
  background: #CCCED4 !important;
  /*-webkit-appearance: none;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,&::-webkit-outer-spin-button{
    -webkit-appearance: none;
    appearance: none;
    margin: 0; !* 如果需要，可以添加额外的样式来调整间距 *!
  }*/
}
</style>